import React from 'react';
import { Link } from 'react-router-dom';
import { db, firebase } from "firebase/fbConfig.js";
import { connect } from 'react-redux';
import compose from 'recompose/compose';

// react component for creating dynamic tables
import ReactTable from "react-table";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";

class TripViewer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            trip: null,
            dataLoaded: false
        }
        this.tripID = window.location.pathname.split('/')[2];
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        db.collectionGroup('haney-trips').where('id', '==', this.tripID).get()
            .then(snap => {

                const docData = snap.docs.map(doc => ({
                    ...doc.data(),
                    id: doc.id
                }))[0]
                this.setState({
                    trip: docData,
                    dataLoaded: true
                })
            })
    }
    render() {
        const { trip } = this.state;

        console.log(this.state);
        return this.state.dataLoaded ? (
            <GridContainer>
                <GridItem xs={12}>
                    <Link to={`/trips/${this.tripID}/edit`}>
                        <Button 
                            color='primary'
                        >
                            EDIT
                        </Button>
                    </Link>
                </GridItem>
                <GridItem xs={12}>
                    <h3>Trip Details:</h3>
                </GridItem>
                <GridItem xs={12}>
                    <p>Vendor Name: {trip.vendorName}</p>
                    <p>Driver Name: {trip.driverName}</p>
                    <p>Orders: {trip.freightBillNumbers}</p>
                    <p>Pick Up Shipper: {trip.pickUpShipperName}</p>
                    <p>Pick Up Shipper Location: {trip.pickUpShipperCity}</p>
                    <p>Drop Off Shipper: {trip.dropOffShipperName}</p>
                    <p>Drop Off Shipper Location: {trip.dropOffShipperCity}</p>
                    <br />
                    <p>Pick Up Address: {trip.pickUpLocation.address}</p>
                    <p>Pick Up City: {trip.pickUpLocation.city}</p>
                    <p>Pick Up State: {trip.pickUpLocation.state}</p>
                    <p>Pick Up Zip: {trip.pickUpLocation.zip}</p>
                </GridItem>
                <GridItem xs={12}>
                    <h3>Order Details</h3>
                </GridItem>
                {trip.orders.map((order, i) => (
                    <GridItem xs={12} key={i}>
                        <br />
                        <p><b>Order {i + 1} - {order.freightBillNumber}</b></p><br />
                        <p>Origin Shipper: {order.pickUpShipperName}</p>
                        <p>Origin Shipper Location: {order.pickUpCityState}</p>
                        <p>Destination Shipper: {order.dropOffShipperName}</p>
                        <p>Destination Shipper Location: {order.dropOffCityState}</p>
                    </GridItem>
                ))}
            </GridContainer>
        ) : (
                <p>Loading...</p>
            )
    }
}

export default TripViewer;


// WEBPACK FOOTER //
// ./src/views/Trips/TripViewer.jsx